import TimecardSummaryBase from './TimecardSummaryBase';
import { timecardSummaryRouteManager } from '../main-navigation/RouteManager';

class TimecardSummaryModel extends TimecardSummaryBase {
  get isLoading(): boolean {
    return super.isLoading || timecardSummaryRouteManager.isLoading;
  }
}

const timecardSummaryModel = new TimecardSummaryModel();
export default timecardSummaryModel;
